import { kaspreadsheetUrl, stats } from "@/mocks/categories";

export default function AboutSection() {
  return (
    <section className="flex flex-col lg:flex-row min-h-[450px] bg-white">
      <div className="lg:w-3/5 px-4 md:px-8 lg:px-16 py-16 md:py-20 flex flex-col justify-center">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-extrabold text-foreground-950 font-heading leading-[1.15] mb-10">
          Por Que Escolher
          <br />
          Hoobuy Sheet?
        </h2>

        <div className="flex items-start divide-x divide-background-200/70">
          {stats.map((stat, idx) => (
            <div key={idx} className="flex-1 px-6 first:pl-0 last:pr-0">
              <p className="text-4xl md:text-5xl font-extrabold text-secondary-500 font-heading mb-2">
                {stat.value}
              </p>
              <p className="text-foreground-500 text-sm">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="lg:w-2/5 relative overflow-hidden min-h-[300px] lg:min-h-[450px] bg-gradient-to-br from-secondary-100 via-secondary-50 to-accent-50">
        <div className="absolute top-1/4 right-1/4 w-32 h-32 rounded-3xl bg-secondary-200/40 rotate-12"></div>
        <div className="absolute bottom-1/3 left-1/4 w-24 h-40 rounded-3xl bg-accent-200/30 -rotate-6"></div>
        <div className="absolute top-1/3 left-1/3 w-20 h-20 rounded-full bg-secondary-300/25"></div>
        <div className="absolute bottom-1/4 right-1/3 w-28 h-28 rounded-2xl bg-accent-200/35 rotate-45"></div>
      </div>
    </section>
  );
}